import { create } from 'zustand';
import { applyTheme } from '@/design-system/theme';

type ThemeMode = 'dark' | 'light';

const STORAGE_KEY = 'pwa-theme';

function getInitialMode(): ThemeMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') {
      return stored;
    }
  } catch {
    // localStorage may be unavailable (SSR, privacy mode, etc.)
  }
  return 'dark';
}

interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
  setMode: (mode: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  mode: getInitialMode(),

  toggle: () =>
    set((state) => {
      const next: ThemeMode = state.mode === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // ignore storage errors
      }
      applyTheme(next);
      return { mode: next };
    }),

  setMode: (mode: ThemeMode) =>
    set(() => {
      try {
        localStorage.setItem(STORAGE_KEY, mode);
      } catch {
        // ignore storage errors
      }
      applyTheme(mode);
      return { mode };
    }),
}));
